export const ADMISSION_REVIEW_CHECKPOINT = 'admission_review'

export const ADMISSION_REVIEW_CHECKPOINT_LABEL = 'Xét duyệt nhập học'

export function isAdmissionReviewResult(item) {
  return item?.checkpoint === ADMISSION_REVIEW_CHECKPOINT
}

export function getAdmissionReviewResult(item) {
  return (item?.admissionResult || []).find(result => isAdmissionReviewResult(result))
}

export function getPublishedAdmissionResults(admissionResult) {
  return (admissionResult || []).filter(result => !isAdmissionReviewResult(result))
}